import { z } from 'zod';

import { BOLD, GREEN, RED, RESET } from '../../config';

// Schema for environment variables
const envSchema = z.object({
  API_URL: z.url({ message: 'required' }),
  NODE_ENV: z.enum(['development', 'production']),
  BETTER_AUTH_SECRET: z.string().min(1),
  BETTER_AUTH_URL: z.url({ message: 'required' }),
  GOOGLE_CLIENT_ID: z.string().min(1),
  GOOGLE_CLIENT_SECRET: z.string().min(1),
  DATABASE_URL: z.string().min(1, { message: 'required' }),
});

const rowEnv = {
  API_URL: process.env.API_URL,
  NODE_ENV: process.env.NODE_ENV,
  BETTER_AUTH_SECRET: process.env.BETTER_AUTH_SECRET,
  BETTER_AUTH_URL: process.env.BETTER_AUTH_URL,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
  GOOGLE_CLIENT_SECRET: process.env.GOOGLE_CLIENT_SECRET,
  DATABASE_URL: process.env.DATABASE_URL,
};

// Validate env
const envValidationResult = envSchema.safeParse(rowEnv);
export const serverEnv = envValidationResult.success ? envValidationResult.data : undefined;

export const validateServerEnv = () => {
  if (!envValidationResult.success) {
    const { formErrors, fieldErrors } = z.flattenError(envValidationResult.error);

    const errorMessages = [];

    // Add form-level errors
    formErrors.forEach((msg, i) => {
      errorMessages.push(`   ${i + 1}) ${msg}`);
    });

    // Add field-level errors
    Object.entries(fieldErrors).forEach(([field, errs]) => {
      errs.forEach((msg) => {
        errorMessages.push(`   - ${field}: ${msg}`);
      });
    });

    throw `\n ${BOLD}${RED}✗${RESET} Error in loading server environment variables:\n${errorMessages.join(
      '\n'
    )}\n\n Please update the environment variables and relaunch the application.`;
  }

  console.info(` ${BOLD}${GREEN}✓${RESET} Server Environment variables loaded successfully`);
};
